import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IPlanAdoptionRateState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const PlanAdoptionRateEmptyState: IPlanAdoptionRateState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
